import { NgModule } from '@angular/core';

// Include the components so the types are available
import '@anjuna/core';

// Common type stuff
import { DraggableDirective } from './common/drag-drop/draggable.directive';
import { DroppableDirective } from './common/drag-drop/droppable.directive';
import { LocaleDirective } from './common/locale/locale.directive';
import { TemplateDirective } from './common/template/template.directive';
import { TransitionDirective } from './common/transition/transition.directive';
import { ZuoraDatePipe } from './common/pipes/date.pipe';

// Forms
import { BooleanValueDirective } from './forms/directives/boolean-value.directive';
import { DateValidatorDirective } from './forms/directives/date.directive';
import { DatetimePickerDirective } from './forms/directives/datetime-picker.directive';
import { RequiredCheckDirective } from './forms/directives/required-check.directive';
import { SelectValueDirective } from './forms/directives/select-value.directive';
import { ListValueDirective } from './forms/directives/list-value.directive';
import { DatePickerDirective } from './forms/directives/date-picker.directive';
import { TextValueDirective } from './forms/directives/text-value.directive';
import { TimePickerDirective } from './forms/directives/time-picker.directive';
import { TIME_MERIDIEM } from './forms/interfaces/Tokens';

// Tables
import { AnjTable } from './table/table.directive';

const DECLARATIONS = [
    // Common
    DraggableDirective,
    DroppableDirective,
    LocaleDirective,
    TemplateDirective,
    TransitionDirective,
    ZuoraDatePipe,
    // Forms
    BooleanValueDirective,
    DatePickerDirective,
    DatetimePickerDirective,
    DateValidatorDirective,
    ListValueDirective,
    RequiredCheckDirective,
    SelectValueDirective,
    TextValueDirective,
    TimePickerDirective,
    // Tables
    AnjTable
];

/* TODO: remove hack at some point..
    https://github.com/ionic-team/stencil/issues/1318
    Stencil State Tunnel (introduced in @anjuna/core locale component) brings the JSX type without definition
    Mock the namespace to bypass the compile error -c
 */
/* tslint:disable:no-empty-interface */
declare global {
    namespace JSX {
        export interface Element { }
    }
}

@NgModule({
    declarations: DECLARATIONS,
    exports: DECLARATIONS,
    providers: [
        {
            provide: TIME_MERIDIEM,
            useValue: true
        },
        ZuoraDatePipe
    ]
})
export class AnjunaCoreModule {}
